var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button, Form, Icon, Input, InputNumber, message, Modal, Tabs, Tooltip, Upload } from 'antd';
import * as _ from 'lodash';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import NumberFormat from 'react-number-format';
import form from 'src/shared/decorators/form';
import Page from 'src/shared/layout/Page';
import services from 'src/shared/services/services';
import stores from 'src/stores/stores';
import DetailTabs from './DetailTabs';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {};
        _this.loading = true;
        _this.multipliers = [];
        _this.scores = [];
        _this.companyScores = [];
        _this.companyFileCategories = [];
        _this.companyScoreNote = {};
        _this.modal = {
            guncelleme: false
        };
        _this.isDegerlendirici = false;
        _this.isDegerlendiriciEdit = false;
        _this.refresh = function () {
            var id = _this.props.match.params.id;
            services.Company.get(id).then(function (c) { return (_this.model = c); });
        };
        _this.save = function () {
            _this.loading = true;
            services.CompanyScoreNote.save(_this.companyScoreNote);
            services.CompanyScore.save(_this.props.match.params.id, _this.companyScores).then(function (c) {
                _this.loading = false;
                message.success('Puanlama başarıyla kaydedildi..');
            });
        };
        _this.onGuncellemeGonder = function () {
            _this.props.form.validateFields(function (errors, values) {
                if (!errors) {
                    _this.modal.guncelleme = false;
                    _this.loading = true;
                    services.Company.guncellemeyeGonder(_this.model.id, values.mesaj).then(function () {
                        _this.loading = false;
                        message.success('Güncellemeye gönderildi...');
                    });
                }
            });
        };
        return _this;
    }
    default_1.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var id, _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        id = this.props.match.params.id;
                        _a = this;
                        return [4 /*yield*/, services.Company.get(id)];
                    case 1:
                        _a.model = _f.sent();
                        _b = this;
                        return [4 /*yield*/, services.Score.getAll(null, null)];
                    case 2:
                        _b.scores = _f.sent();
                        _c = this;
                        return [4 /*yield*/, services.CompanyScore.getScores(id)];
                    case 3:
                        _c.companyScores = _f.sent();
                        _d = this;
                        return [4 /*yield*/, services.CompanyScoreNote.getByCompany(id)];
                    case 4:
                        _d.companyScoreNote = (_f.sent()) || { companyId: id };
                        this.loading = false;
                        this.isDegerlendirici = stores.auth.hasRole('değerlendirici');
                        this.isDegerlendiriciEdit = this.isDegerlendirici;
                        if (this.isDegerlendiriciEdit) {
                            this.isDegerlendiriciEdit = this.model.status !== 'Nihai Rapor';
                        }
                        _e = this;
                        return [4 /*yield*/, services.CompanyFileCategory.getAll()];
                    case 5:
                        _e.companyFileCategories = _f.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    default_1.prototype.render = function () {
        var _this = this;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var itemLayout = {
            labelCol: { span: 14 },
            wrapperCol: { span: 10 }
        };
        var renderFinancialYears = function (c) {
            return (c &&
                Object.keys(c).map(function (key) {
                    return {
                        yil: key.replace('y_', ''),
                        val: c[key]
                    };
                }));
        };
        var legends = [
            {
                name: 'Yatırımcı Bilgileri',
                items: [
                    { key: 'basvuruNo', name: 'Başvuru No' },
                    {
                        key: 'isIndividual',
                        name: 'Firma Türü',
                        value: function (c) { return (c ? 'Şahıs Firması' : 'Tüzel Kişi'); }
                    },
                    { key: 'name', name: 'Firma Ünvanı' },
                    { key: 'yetkili', name: 'Yetkili Ad Soyad' },
                    { key: 'adres', name: 'Adres' },
                    { key: 'sehir', name: 'Şehir', value: function (c) { return stores.constant.get(c) && stores.constant.get(c).name; } },
                    { key: 'telefon', name: 'Telefon' },
                    { key: 'fax', name: 'Fax' },
                    { key: 'email', name: 'Email' },
                    { key: 'web', name: 'Web Adresi' },
                    { key: 'ticaretSicilNo', name: 'Ticaret / Esnaf Sicil No' },
                    { key: 'ticaretOdasi', name: 'Ticaret / Esnaf Odası' },
                    { key: 'vergiNumarasi', name: 'Vergi Numarası' },
                    { key: 'vergiDairesi', name: 'Vergi Dairesi' },
                    { key: 'sgkSicilNo', name: 'Sgk Sicil No' },
                    {
                        key: 'kayitliSermaye',
                        name: 'Kayıtlı Sermaye',
                        value: function (e) { return React.createElement(NumberFormat, { thousandSeparator: ".", decimalSeparator: ",", decimalScale: 2, value: e, displayType: 'text', prefix: "\u20BA " }); }
                    },
                    {
                        key: 'odenmisSermaye',
                        name: 'Ödenmiş Sermaye',
                        value: function (e) { return React.createElement(NumberFormat, { thousandSeparator: ".", decimalSeparator: ",", decimalScale: 2, value: e, displayType: 'text', prefix: "\u20BA " }); }
                    },
                    { key: 'adSoyad', name: 'Ad Soyad' },
                    { key: 'tcKimlikNo', name: 'Tc Kimlik No' }
                ]
            },
            {
                name: 'Finansal Bilgiler',
                items: [
                    {
                        key: 'metas.sonUcYillikCiro',
                        name: 'Son Üç Yıllık Ciro',
                        value: function (c) { return renderFinancialYears(c); }
                    },
                    {
                        key: 'metas.netKarZarar',
                        name: 'Net Kâr / Zarar',
                        value: function (c) { return renderFinancialYears(c); }
                    },
                    {
                        key: 'metas.ihracatTutari',
                        name: 'İhracat Tutarı',
                        value: function (c) { return renderFinancialYears(c); }
                    },
                    {
                        key: 'metas.kisaVeUzunVade',
                        name: 'Kısa ve Uzun Vadeli..',
                        value: function (c) { return renderFinancialYears(c); }
                    }
                ]
            },
            {
                name: 'Firma Özgeçmişi',
                items: [
                    { key: 'kurulusTarihi', name: 'Firma Kuruluş Tarihi' },
                    { key: 'yatirimTesvikBelgesiNo', name: 'Yatırım Teşnik Belgesi No' },
                    {
                        key: 'mevcutFaaliyetGosterdigiYer',
                        name: 'Firmanın Mevcut Faaliyet Gösterdiği Yer',
                        value: function (c) { return stores.constant.get(c) && stores.constant.get(c).name; }
                    },
                    { key: 'mevcutAcikAlan', name: 'Mevcut Açık Alan Büyüklüğü(m2)' },
                    { key: 'mevcutKapaliAlan', name: 'Mevcut Kapalı Alan Büyüklüğü(m2)' },
                    {
                        key: 'metas.ozgecmis.istigalAlanlariVeUretimDeneyimi',
                        name: 'Firmanın Önceki İştigal Alanları ve Üretim Deneyimi'
                    },
                    {
                        key: 'metas.ozgecmis.yerDegisiklikleriVeBuyumeAsamalari',
                        name: 'Firmanın Geçmişteki Yer Değişiklikleri ve Büyüme Aşamaları'
                    },
                    {
                        key: 'metas.ozgecmis.ihracatYapilanEsasUlkelerUrunler',
                        name: 'İhracat Yapılan Esas Ülkeler & Ürünler'
                    },
                    {
                        key: 'metas.ozgecmis.firmayaAitTescilliMarkalar',
                        name: 'Firmaya ait Tescilli Markalar, Patentler, Faydalı Modeller'
                    },
                    {
                        key: 'metas.ozgecmis.firmaninPazarlamaAltyapisi',
                        name: 'Firmanın Pazarlama Altyapısı'
                    },
                    {
                        key: 'metas.ozgecmis.argeUrunGelistirmeAltyapisi',
                        name: 'Ar-Ge ve Ürün Geliştirme Altyapısı'
                    },
                    {
                        key: 'metas.ozgecmis.referanslar',
                        name: 'Referanslar'
                    }
                ]
            },
            {
                name: 'Yatırıma İlişkin Bilgiler',
                items: [
                    {
                        key: 'yatiriminSektoruVeKonusu',
                        name: 'Yatırımın Sektörü ve Konusu',
                        value: function (c) { return stores.constant.get(c) && stores.constant.get(c).name; }
                    },
                    {
                        key: 'yatiriminCinsi',
                        name: 'Yatırım Cinsi',
                        value: function (c) { return stores.constant.get(c) && stores.constant.get(c).name; }
                    },
                    { key: 'uretilecekUrunler', name: 'Üretilecek Ürünler' },
                    { key: 'ongorulenYatirimBaslangicTarihi', name: 'Öngörülen Yatırım Başlangıç Tarihi' },
                    { key: 'ongorulenYatirimBitisTarihi', name: 'Öngörülen Yatırım Bitiş Tarihi' },
                    { key: 'ongorulenIsletmeyeGecisTarihi', name: 'Öngörülen İşletmeye Geçiş Tarihi' },
                    {
                        key: 'ongorulenIstihdamSayisiMavi',
                        name: 'Öngörülen İstihdam Sayısı',
                        value: function (c) { return (React.createElement("div", null,
                            "Mavi Yakal\u0131: ",
                            _this.model.ongorulenIstihdamSayisiMavi,
                            ", Beyaz Yakal\u0131: ",
                            _this.model.ongorulenIstihdamSayisiBeyaz,
                            ", Toplam:",
                            ' ',
                            _this.model.ongorulenIstihdamSayisiBeyaz + _this.model.ongorulenIstihdamSayisiMavi)); }
                    },
                    {
                        key: 'sabitYatirimTutariToplam',
                        name: 'Sabit Yatırım Tutarı (TL) ',
                        value: function (c) { return (React.createElement("div", null,
                            "Toplam:",
                            ' ',
                            React.createElement(NumberFormat, { thousandSeparator: ".", decimalSeparator: ",", decimalScale: 2, value: _this.model.sabitYatirimTutariToplam, displayType: 'text', prefix: "\u20BA " }),
                            ", \u00D6z Sermaye:",
                            ' ',
                            React.createElement(NumberFormat, { thousandSeparator: ".", decimalSeparator: ",", decimalScale: 2, value: _this.model.sabitYatirimTutariOz, displayType: 'text', prefix: "\u20BA " }),
                            ", Kredi:",
                            React.createElement(NumberFormat, { thousandSeparator: ".", decimalSeparator: ",", decimalScale: 2, value: _this.model.sabitYatirimTutariKredi, displayType: 'text', prefix: "\u20BA " }))); }
                    },
                    { key: 'talepEdilenToplamAlan', name: 'Talep Edilen Toplam Alan (m2)' },
                    { key: 'planlananKapaliAlan', name: 'Planlanan Kapalı Alan (m2)' },
                    { key: 'metas.yatirim.yatirimaKonuProjeninKisaAnlatimi', name: 'Yatırıma Konu Projenin Kısa Anlatımı' },
                    { key: 'metas.yatirim.isletmedeOngorulenKuruluGuc', name: 'İşletmede Öngörülen Kurulu Güç' },
                    {
                        key: 'metas.yatirim.tesisOztuketimiIcınYenilenebilirEnerji',
                        name: 'Tesis Öztüketimi için Yenilenebilir Enerji Yatırımı Düşünülüyor mu?'
                    },
                    { key: 'metas.yatirim.yatirimCedGerektirecekMi', name: 'Yatırım ÇED Gerektirecek mi?Çevresel Açıdan Olası Etkiler' },
                    { key: 'metas.yatirim.yatiriminYanSanayiOlusturmaEtkisi', name: 'Yatırımın Yan Sanayi Oluşturma Etkisi' },
                    { key: 'metas.yatirim.yatiriminizinEtkileyecegiSektorler', name: 'Yatırımınızın doğrudan etkileyeceği/tetikleyeceği diğer sektörler' },
                    { key: 'metas.yatirim.osbdeTahsisTalebiGerekceleri', name: 'OSB de tahsis talebinin gerekçeleri' }
                ]
            }
        ];
        var ortalama = 0;
        this.scores.map(function (score) {
            ortalama += _.get(_.find(_this.companyScores, { scoreId: score.id }), 'value') * score.multiplier;
        });
        return (React.createElement(Page, { buttons: React.createElement("div", null,
                !this.loading && !(stores.auth.hasRole('osb yetkilisi') && this.model.status === 'Değerlendirmede') && (React.createElement(Button, { onClick: function () { return (_this.modal.guncelleme = true); } }, "G\u00FCncelleme Firma Geri G\u00F6nder")),
                (stores.auth.hasRole('administrator') || stores.auth.hasRole('osb yetkilisi')) && this.model.status === 'Başvuru Tamamlandı' && (React.createElement(Button, { type: "primary", onClick: function () {
                        return services.Company.setStatus(_this.model.id, 'Başvuru Onaylandı').then(function () {
                            message.success('Durum güncellendi!');
                            _this.refresh();
                        });
                    } }, "Ba\u015Fvuru Onayla")),
                this.isDegerlendirici && this.isDegerlendiriciEdit && (React.createElement(Button, { loading: this.loading, type: "primary", onClick: this.save }, "Kaydet"))), breadcrumbs: [{ link: '/common/company', text: 'Başvurular' }], loading: this.loading, title: 'Başvuru: ' + this.model.name },
            React.createElement("div", { className: "card-body" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: this.isDegerlendirici ? 'col-md-8' : 'col-md-12' },
                        React.createElement(DetailTabs, { startKey: 0, model: this.model, append: React.createElement(Tabs.TabPane, { key: '6', tab: "Z\u0130YARETLER" },
                                React.createElement("div", { style: { marginBottom: 20 } },
                                    React.createElement(Upload, { listType: "picture-card", onRemove: function (c) {
                                            Modal.confirm({
                                                title: 'Dosyayı silmek istediğinizden emin misiniz?',
                                                onOk: function () {
                                                    services.Company.fileRemove(_this.model.id, c.uid)
                                                        .then(function () {
                                                        message.success('Dosya başarıyla bir şekilde silindi!');
                                                    })
                                                        .catch(function () {
                                                        message.error('Dosya silinirken hata oluştu!');
                                                    });
                                                    _this.refresh();
                                                }
                                            });
                                        }, fileList: this.model.files &&
                                            this.model.files
                                                .filter(function (c) { return c.categoryId === 9; })
                                                .map(function (c) {
                                                return {
                                                    uid: c.id,
                                                    name: c.name,
                                                    url: location.origin + '/uploads/' + _this.model.id + '-' + c.id + c.extension
                                                };
                                            }), action: location.origin + '/api/Common/CompanyService/FileUpload?companyId=' + this.model.id, onChange: function (info) {
                                            if (info.file.status === 'done') {
                                                message.success('Dosya başarıyla yüklendi!');
                                            }
                                            else if (info.file.status === 'error') {
                                                message.error('Dosya yüklenirken hata oluştu!');
                                            }
                                            setTimeout(function () {
                                                _this.refresh();
                                            }, 300);
                                        } },
                                        React.createElement(Button, null,
                                            React.createElement(Icon, { type: "upload" }),
                                            " Y\u00FCkle")),
                                    React.createElement(Form.Item, { label: "Ortak Ziyaret Notlar\u0131" },
                                        React.createElement(Input.TextArea, { rows: 3, value: this.model.ziyaretNotlari, onChange: function (c) {
                                                _this.model.ziyaretNotlari = c.target.value;
                                                _this.forceUpdate();
                                            } })))) })),
                    this.isDegerlendirici && (React.createElement("div", { className: "col-md-4" },
                        React.createElement(Tabs, { defaultActiveKey: "1", className: "ant-tab-mini" },
                            React.createElement(Tabs.TabPane, { key: "1", tab: "DE\u011EERLEND\u0130RME" },
                                React.createElement(Form, null,
                                    this.scores.map(function (score) { return (React.createElement(Form.Item, { key: score.id, label: React.createElement("span", null,
                                            score.name,
                                            ' ',
                                            React.createElement(Tooltip, { title: React.createElement("div", { dangerouslySetInnerHTML: { __html: score.description } }) },
                                                React.createElement(Icon, { type: "info-circle" }))) },
                                        React.createElement(InputNumber, { disabled: !_this.isDegerlendiriciEdit, max: 100, min: 0, style: { width: '100%' }, placeholder: "0-100", value: _.get(_.find(_this.companyScores, { scoreId: score.id }), 'value'), onChange: function (c) {
                                                if (!_this.companyScores.some(function (cs) { return cs.scoreId === score.id; })) {
                                                    _this.companyScores.push({
                                                        companyId: _this.props.match.params.id,
                                                        value: c,
                                                        scoreId: score.id
                                                    });
                                                }
                                                _this.companyScores.find(function (cmp) { return cmp.scoreId === score.id; }).value = c;
                                                _this.forceUpdate();
                                            } }))); }),
                                    React.createElement(Form.Item, { label: "Proje \u00D6zeti" },
                                        getFieldDecorator('projeOzeti', { initialValue: this.companyScoreNote.projeOzeti })(React.createElement(Input.TextArea, { disabled: !this.isDegerlendiriciEdit, maxLength: 1000, rows: 8, onChange: function (c) { return (_this.companyScoreNote.projeOzeti = c.target.value); } })),
                                        React.createElement("span", { className: "ant-form-explain", style: { float: 'right' } },
                                            (this.companyScoreNote.projeOzeti && this.companyScoreNote.projeOzeti.length) || 0,
                                            " / 1000")),
                                    React.createElement(Form.Item, { label: "De\u011Ferlendirme Notlar\u0131" },
                                        getFieldDecorator('degerlendirmeNotlari', { initialValue: this.companyScoreNote.degerlendirmeNotlari })(React.createElement(Input.TextArea, { disabled: !this.isDegerlendiriciEdit, maxLength: 2000, rows: 8, onChange: function (c) { return (_this.companyScoreNote.degerlendirmeNotlari = c.target.value); } })),
                                        React.createElement("span", { className: "ant-form-explain", style: { float: 'right' } },
                                            (this.companyScoreNote.degerlendirmeNotlari && this.companyScoreNote.degerlendirmeNotlari.length) || 0,
                                            " / 2000")),
                                    React.createElement(Form.Item, { key: 'ortalama', label: React.createElement("span", null,
                                            "Ortalama",
                                            ' ',
                                            React.createElement(Tooltip, { title: "De\u011Ferlendirme Ortalaman\u0131z" },
                                                React.createElement(Icon, { type: "info-circle" }))) },
                                        React.createElement(InputNumber, { disabled: true, max: 100, min: 0, style: { width: '100%' }, placeholder: "Puanlama yap\u0131l\u0131nca g\u00FCncellenecektir.", value: ortalama }))))))))),
            React.createElement(Modal, { visible: this.modal.guncelleme, onOk: this.onGuncellemeGonder, onCancel: function () { return (_this.modal.guncelleme = false); } },
                React.createElement(Form, null,
                    React.createElement(Form.Item, { label: "Mesaj" }, this.props.form.getFieldDecorator('mesaj', {
                        rules: [{ required: true, message: 'Alan gerekli!' }]
                    })(React.createElement(Input.TextArea, { rows: 10, placeholder: "Mesaj\u0131n\u0131z\u0131 girin.." })))))));
    };
    __decorate([
        observable
    ], default_1.prototype, "model", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loading", void 0);
    __decorate([
        observable
    ], default_1.prototype, "multipliers", void 0);
    __decorate([
        observable
    ], default_1.prototype, "scores", void 0);
    __decorate([
        observable
    ], default_1.prototype, "companyScores", void 0);
    __decorate([
        observable
    ], default_1.prototype, "companyFileCategories", void 0);
    __decorate([
        observable
    ], default_1.prototype, "companyScoreNote", void 0);
    __decorate([
        observable
    ], default_1.prototype, "modal", void 0);
    __decorate([
        observable
    ], default_1.prototype, "isDegerlendirici", void 0);
    __decorate([
        observable
    ], default_1.prototype, "isDegerlendiriciEdit", void 0);
    default_1 = __decorate([
        form,
        observer
    ], default_1);
    return default_1;
}(React.Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/app/common/company/Edit.tsx
// module id = 1263
// module chunks = 0